<template>
  <b-card>
    <plant-edit-tab 
      v-if="plantData" 
      :plant-data="plantData"  
      class="mt-2 pt-75" 
    />
  </b-card>
</template>

<script>
import PlantEditTab from './PlantEditTab.vue'
import {
  VBToggle, VBModal, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, BFormSelect, BSidebar
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import plantStoreModule from './plantStoreModule'

export default {
  name: 'plant-edit',
  components: {
    PlantEditTab,
    VBToggle, VBModal, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormGroup, BFormSelect, BSidebar
  },
  data() {
    return {
      id: router.currentRoute.params.id
    }
  },
  setup() {
    const plantData = ref(null)

    const PLANT_APP_STORE_MODULE = 'hr-plant'
    // Register module
    if (!store.hasModule(PLANT_APP_STORE_MODULE)) {
      store.registerModule(PLANT_APP_STORE_MODULE, plantStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PLANT_APP_STORE_MODULE)) {
        store.unregisterModule(PLANT_APP_STORE_MODULE)
      }
    })

    store.dispatch('fetchPlant', { id: router.currentRoute.params.id })
      .then(response => { 
        plantData.value = response.data 
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          plantData.value = undefined
        }
      })

    return {
      plantData
    }
  }
}
</script>

<style scoped>
</style>

